import {L} from "./landcare-toolkit";
import Item = L.tree.Item;
import {ILayerQueryLayer, IRow} from "../services/layer_query";
import {_F} from "../utility/func";
import flatMap = _F.flatMap;
import filterNodes = L.tree.filterNodes;
import {IPointReport} from "../services/ISharedFeatureState";

export interface IPointQueryResult {
    name: string;
    data: {
        name: string;
        description?: string | number;
        colour?: string;
        value: string|number| { [key: string]: any };
    }[]
}

export function processOEPointQueryResult(data: IPointReport, scienceLayers: Item[], treeData?: Item|Item[]): IPointQueryResult[] {
    return data.response
        .layers.map<IPointQueryResult>((l: ILayerQueryLayer) => {
            let rows = l.rows;
            let maybeColours = treeData ? rows.map(r => classColour(l, r, treeData))
                .filter(c => c) : [];

            let data: IPointQueryResult['data'] = rows.map((r) => r.columns)
                .reduce((acc, cs) => acc.concat(cs), [])
                // don't items that are for internal use only
                .filter((c) => (c.name && c.name.indexOf("INTERNAL_") !== 0) || !c.name)
                // don't items without a value
                .filter((c) => c.value !== undefined)
                .map((c) => {
                    if (c.name !== 'Description') {
                        let colour = c.name == 'Class' && maybeColours.length ? maybeColours[0] : null;
                        if (colour) {
                            c.colour = colour;
                        }
                        return c;
                    }

                    return c/* {
                        name: c.name,
                        description: c.value
                    }*/
                });

            let layerName = l.name;
            let layer = scienceLayers.filter((sc) => sc.layerService.layerName == layerName);
            let name = layer.length ? layer[0].name : '';

            return {
                name,
                data
            }
        });
}

const COLOUR_KEY = 'INTERNAL_COLOUR';

export function classColour(layer: ILayerQueryLayer, row: IRow, treeData: Item|Item[]) : string {
    try {
        let colour = row.columns.filter(r => r.name == COLOUR_KEY)[0];
        return flatMap(filterNodes(treeData, l => {
            return l && l.layerService && l.layerService.layerName == layer.name;
        }), (l) => l.layerService.CLASS)
            .filter((cl) => cl.param == (parseInt(colour.value.toString()) - 1))
            .map(cl => cl.classColor)[0];
    } catch (e) {

    }
    return null;
}
